// Presentation helpers: never normalize or rewrite a saved profile.
export const getConfigurationMode = profile => {
  const policy = profile?.metadata?.operationalPolicy;
  if (policy == null) return "legacy";
  return policy.version === 1 && policy.transfer && Array.isArray(policy.transfer.destinationKeys) &&
    policy.followUp && policy.inactivity && policy.communication &&
    typeof policy.transfer.enabled === "boolean" && typeof policy.followUp.enabled === "boolean" &&
    typeof policy.inactivity.enabled === "boolean" ? "operational" : "unsupported";
};

export const destinationUnavailableReason = (destination, userId) => {
  if (Number(destination.assignee?.id) === Number(userId) && userId != null) return "selfDestination";
  if (!destination.enabled || !destination.queue?.enabled) return "unavailableDestination";
  if (destination.assignee && !destination.assignee.enabled) return "agentNotReady";
  if (destination.assignee?.type === "ai_agent" && !destination.queue.allowAiAgents) return "aiNotAllowed";
  return null;
};

export const groupDestinations = (catalog, search = "") => {
  const query = search.trim().toLocaleLowerCase();
  const groups = new Map();
  const queueNames = new Map(catalog.filter(d => d.key.startsWith("queue_")).map(d => [d.queue?.id, d.name]));
  for (const destination of catalog) {
    if (!`${destination.name} ${queueNames.get(destination.queue?.id) || ""}`.toLocaleLowerCase().includes(query)) continue;
    const key = destination.queue?.id;
    if (!groups.has(key)) groups.set(key, { key, name: queueNames.get(key) || destination.name, destinations: [] });
    groups.get(key).destinations.push(destination);
  }
  return [...groups.values()];
};

// Bulk actions touch only the eligible entries in the supplied catalog/filtered group.
// Unknown and unavailable saved selections are retained until explicitly reviewed.
export const selectDestinations = (transfer, catalog, userId, selected) => {
  const eligible = new Set(catalog.filter(d => !destinationUnavailableReason(d, userId)).map(d => d.key));
  const keys = selected ? [...new Set([...transfer.destinationKeys, ...eligible])] :
    transfer.destinationKeys.filter(key => !eligible.has(key));
  return { ...transfer, destinationKeys: keys,
    defaultDestinationKey: keys.includes(transfer.defaultDestinationKey) ? transfer.defaultDestinationKey : null };
};

export const getSaveFeedback = (userType, profile, action) => {
  if (userType !== "ai_agent") return "saved";
  if (action === "save_draft") return "draftSaved";
  if (!profile || profile.lastSyncError || profile.status === "error") return "syncPending";
  return Boolean(profile.agentsAgentId && profile.lastSyncAt) ? "synced" : "syncPending";
};
export const getOperationalFailurePolicy = profile => {
  const saved = profile?.metadata?.operationalFailurePolicy;
  if (saved === undefined || saved === null) return { version: 1, transferEnabled: false, queueId: null };
  return saved.version === 1 ? saved : null;
};
export const isHumanFailureQueue = queue => queue.allowManualAttendance !== false &&
  !(queue.defaultAiUserId && queue.aiAssignmentMode !== "disabled");
